var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgModule = function SvgModule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.52,
    height: 18.72,
    viewBox: "0 0 18.52 18.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_2_modu\\u0142_prognostyczny"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.52,
    height: 18.72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2_modu\\u0142_prognostyczny",
    "data-name": "2 modu\\u0142 prognostyczny",
    clipPath: "url(#clip-_2_modu\\u0142_prognostyczny)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M146.628,218.936h-3.442a.522.522,0,0,0-.522.522v6.754a.522.522,0,0,0,.522.522h3.442a.522.522,0,0,0,.522-.522v-6.754A.522.522,0,0,0,146.628,218.936Zm-.522,6.754h-2.4v-5.711h2.4Z",
    transform: "translate(-135.643 -208.009)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M283.013,136.911h-3.468a.522.522,0,0,0-.522.522V148.28a.522.522,0,0,0,.522.522h3.468a.522.522,0,0,0,.522-.522V137.433A.522.522,0,0,0,283.013,136.911Zm-.521,10.848h-2.425v-9.8h2.425Z",
    transform: "translate(-265.196 -130.078)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M9.772,269.613H6.3a.522.522,0,0,0-.522.522v4.224a.521.521,0,0,0,.522.522H9.772a.521.521,0,0,0,.522-.522v-4.224A.522.522,0,0,0,9.772,269.613Zm-.522,4.224H6.825v-3.181H9.25Z",
    transform: "translate(-5.593 -256.156)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M20.393.523a.443.443,0,0,0-.339-.183L15.308,0a.523.523,0,1,0-.078,1.043l3.359.228L12.413,6.1,7.694,2.4a.522.522,0,0,0-.678.026L2.165,7.068a.522.522,0,0,0-.026.73.469.469,0,0,0,.391.183A.521.521,0,0,0,2.9,7.825L7.407,3.5l4.668,3.677a.522.522,0,0,0,.652,0L19.4,1.978l-.261,3.239a.548.548,0,0,0,.5.548h.026a.522.522,0,0,0,.522-.469L20.523.888A.417.417,0,0,0,20.393.523Z",
    transform: "translate(-2.003 0)",
    fill: "#a8b0b6"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/module.ba90259a.svg";
export { ForwardRef as ReactComponent };